import type { BusinessUnit } from '@backend/lib-l10n';
import { createContext, type PropsWithChildren, useContext } from 'react';

import type { BusinessUnitConfig } from '~/config/businessUnits';

export type BusinessUnitContextConfig = BusinessUnitConfig & { businessUnit: BusinessUnit; locale: string };

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const BusinessUnitContext = createContext<BusinessUnitContextConfig>();

export const BusinessUnitContextProvider = ({
  children,
  businessUnitConfig,
}: PropsWithChildren<{ businessUnitConfig: BusinessUnitContextConfig }>) => (
  <BusinessUnitContext.Provider value={businessUnitConfig}>{children}</BusinessUnitContext.Provider>
);

export const useBusinessUnitContext = () => useContext(BusinessUnitContext);
